// extracted by mini-css-extract-plugin
export var progressContainer = "_gs-0";